var map = {
	"./homeIcons/android.png": "8b20",
	"./homeIcons/assign.png": "1f07",
	"./homeIcons/buy.png": "f799",
	"./homeIcons/exclamationMark.png": "2e25",
	"./homeIcons/feedback.png": "d275",
	"./homeIcons/filtrate.png": "061e",
	"./homeIcons/ios.png": "6d5e",
	"./homeIcons/pc.png": "1f01",
	"./homeIcons/retreat.png": "4f00",
	"./homeIcons/sell.png": "3a4b",
	"./homeIcons/star.png": "f604",
	"./homeIcons/starAction.png": "651d",
	"./homeIcons/trigger.png": "ad98",
	"./homeIcons/whiteretreat.png": "b7e2",
	"./icons/home-active.png": "219b",
	"./icons/home.png": "297d",
	"./icons/loading.gif": "48bf",
	"./icons/my-active.png": "75ef",
	"./icons/my.png": "4c67",
	"./icons/order-active.png": "e42d",
	"./icons/order.png": "9681",
	"./img/head/gold.png": "62f2",
	"./img/head/nandaoshi.png": "617d",
	"./img/head/nanfashi.png": "6765",
	"./img/head/nanzhanshi.png": "24e7",
	"./img/head/nvdaoshi.png": "26bd",
	"./img/head/nvfashi.png": "5416",
	"./img/head/nvzhanshi.png": "3b83",
	"./img/login/checked-active.png": "c2b9",
	"./img/login/checked.png": "f57d",
	"./img/login/close.png": "718a",
	"./img/login/icon-close.png": "44cd",
	"./img/login/icon-select-phone.png": "4c5c",
	"./img/login/logo.png": "5fa2",
	"./img/login/password-close.png": "0f16",
	"./img/login/password.png": "d813",
	"./img/login/rightArrow.png": "b25a",
	"./img/my/ICONh5交易行交易行规则.png": "be1c",
	"./img/my/ICONh5交易行意见反馈.png": "5a06",
	"./img/my/ICONh5交易行我的收藏.png": "ad8e",
	"./img/my/ICONh5交易行我的货架.png": "4436",
	"./img/my/ICONh5交易行我要卖.png": "b5b1",
	"./img/my/ICON／箭头／right／Light.png": "dfbc",
	"./img/my/authenticated.png": "3cb0",
	"./img/my/close.png": "ee81",
	"./img/my/delete.png": "2f63",
	"./img/my/fan.png": "7c28",
	"./img/my/hint.png": "e4e1",
	"./img/my/imgAdd-active.png": "59fd",
	"./img/my/imgAdd.png": "5efa",
	"./img/my/logo.png": "59f9",
	"./img/my/new_close.png": "c48b",
	"./img/my/privilege.png": "d564",
	"./img/my/svip_extract_bg.png": "afb3",
	"./img/my/svip_icon.png": "8b91",
	"./img/my/svip_title_left.png": "b039",
	"./img/my/zheng.png": "6c72",
	"./img/mywantobuy/ICON／关闭／搜索框.png": "ba97",
	"./img/mywantobuy/ICON／关闭／菜单展开.png": "f05a",
	"./img/mywantobuy/ICON／搜索／首页／1.png": "f633",
	"./img/mywantobuy/ICON／箭头／Light.png": "aa65",
	"./img/mywantobuy/ICON／菜单／首页.png": "283c",
	"./img/mywantobuy/general.png": "8f4c",
	"./img/svip/icon_dialog_svip_level1.png": "0b78",
	"./img/svip/icon_dialog_svip_level10.png": "dcea",
	"./img/svip/icon_dialog_svip_level2.png": "3fbb",
	"./img/svip/icon_dialog_svip_level3.png": "ae7e",
	"./img/svip/icon_dialog_svip_level4.png": "d0d6",
	"./img/svip/icon_dialog_svip_level5.png": "2fff",
	"./img/svip/icon_dialog_svip_level6.png": "2477",
	"./img/svip/icon_dialog_svip_level7.png": "35fc",
	"./img/svip/icon_dialog_svip_level8.png": "e7fa",
	"./img/svip/icon_dialog_svip_level9.png": "5817",
	"./img/wantToBuy/Group.png": "ac43",
	"./img/wantToBuy/alipay.png": "f4ff",
	"./img/wantToBuy/pull-down.png": "ff97",
	"./img/wantToBuy/right.png": "b499",
	"./img/wantToBuy/top-up.png": "da46",
	"./img/wantToBuy/top_pay.png": "98b5",
	"./img/wantToBuy/user-name.png": "e018",
	"./logo.png": "cf05",
	"./style/global/_color.scss": "1519",
	"./style/global/_icon.scss": "6a43",
	"./style/global/_img.scss": "2f3a",
	"./style/global/index.scss": "1f81",
	"./style/navBar.less": "26a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";